import React from 'react';

const userContext = React.createContext<any>({user: {}});

export { userContext };


// WEBPACK FOOTER //
// ./src/utils/userContext.tsx